import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import { ProgressBar, Button, Nav, Tab, Card } from "react-bootstrap";
import ParentDetails from "../AddStudent/parentDetailsComponent";
import StudentDetails from "../AddStudent/studentDetailsComponent";
import Stepper from 'react-stepper-horizontal';
import { STUDENT, PARENT, PAYMENT, STUDENTTABORDER, ADMISSION, EDIT_ACTION, STUDENT_HISTORY, STUDENT_BIO, DELETE_STUDENT } from "../../constants";
import { useLocation, useParams } from 'react-router';
import { getStatesList, resetStudentDataAction, studentHistoryAction, studentPaymentHistoryAction, studentProfileDetailsAction } from "../../../redux/actions/studentActions";
import moment from "moment";
import StudentHistory from "./studentHisory";
import StudentPaymentHistory from "./studentPaymentHistory";
import Bio from "./bio";
import LeavingCertifcate from "./leavingCertificate";

const EditProfile = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;
  const { loader ,studentProfileDetails  } = useSelector((state) => state.student);
  const [sideMenu, setSideMenu] = useState(true);
  const [studentData, setStudentData] = useState({});
  const [parentData, setParentData] = useState({});
  const [selectedTab, setSelectedTab] = useState(STUDENT_BIO);
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  useEffect(()=>{
    dispatch(resetStudentDataAction())
    if(id){
     async function getStudentProfileDetails(){
       await dispatch(studentProfileDetailsAction({studentId: id}))
       await dispatch(studentHistoryAction({StudentId: id}))
       await dispatch(studentPaymentHistoryAction({StudentId: id
        }))
     }
      getStudentProfileDetails();
    }else{
      setSelectedTab(STUDENT)
    }
    dispatch(getStatesList())
  },[])

  useEffect(() => {
    if(Object.keys(studentProfileDetails).length > 0){
        let studentAddressParams = {
          addressLine: null,
          city:null,
          district:null,
          StateId:null,
          postalCode:null,
          distanceFromSchool:null,
        };
        if(studentProfileDetails.Addresses.length > 0 ){
          studentAddressParams ={
            addressLine: studentProfileDetails.Addresses[0].addressLine,
            city: studentProfileDetails.Addresses[0].city,
            district: studentProfileDetails.Addresses[0].district,
            StateId: {value : studentProfileDetails.Addresses[0].State.id , label: studentProfileDetails.Addresses[0].State.name } ,
            postalCode: studentProfileDetails.Addresses[0].postalCode,
            distanceFromSchool: studentProfileDetails.Addresses[0].distanceFromSchool,
          }
        }
      const studentParams = {
        id:parseInt(id),
        BranchId: {value : studentProfileDetails.Branch.id , label: studentProfileDetails.Branch.name },
        ClassGroupId: {value : studentProfileDetails.ClassGroupId , label: studentProfileDetails.ClassGroup.name },
        academicStartDate: moment(studentProfileDetails.academicStartDate).format("YYYY-MM-DD"),
        academicEndDate: moment(studentProfileDetails.academicEndDate).format("YYYY-MM-DD"),
        firstName: studentProfileDetails.User.firstName,
        lastName: studentProfileDetails.User.lastName,
        email: studentProfileDetails.User.email,
        lastSchoolAttend: studentProfileDetails.lastSchoolAttend,
        dob: studentProfileDetails.dob,
        gender:{value : studentProfileDetails.gender , label: studentProfileDetails.gender } ,
        phoneNumber: (studentProfileDetails.User.phoneNumber),
        religion: studentProfileDetails.religion,
        caste: studentProfileDetails.caste,
        BloodGroupId: {value : studentProfileDetails.BloodGroup.id , label: studentProfileDetails.BloodGroup.name },
        problemsOrFears: studentProfileDetails.problemsOrFears,
        taxBenfits: String(studentProfileDetails.taxBenfits),
        languages: studentProfileDetails.User.language_info.filter(obj=>{
          obj.label = obj.name;
          obj.value = obj.id
          return obj;
        }),
        ...studentAddressParams
      }
      const fatherData = studentProfileDetails.guardian_info.filter(obj=> obj.gender === 'Male');
      const motherData = studentProfileDetails.guardian_info.filter(obj=> obj.gender === 'Female');
      let parentAddress = {
          id:null,
          name:null,
          email:null,
          dob:null,
          phone:null,
          occupation:null,
          altPhoneNumber:null,
          addressLine: null,
          city:null,
          district:null,
          StateId:null,
          postalCode:null,
      }
      let parentParams = {
        father: { ...parentAddress},
        mother: { ...parentAddress}
      }
      if(fatherData.length > 0){
        if(fatherData[0].Addresses.length > 0 ){
            parentParams.father = {
              id: fatherData[0].id ,
              name: fatherData[0].name,
              email: fatherData[0].email,
              dob: fatherData[0].dob,
              phone: (fatherData[0].phone),
              occupation: fatherData[0].occupation,
              altPhoneNumber: fatherData[0].altPhoneNumber ? (fatherData[0].altPhoneNumber) : null ,
              addressLine: fatherData[0].Addresses[0].addressLine,
              city: fatherData[0].Addresses[0].city,
              district: fatherData[0].Addresses[0].district,
              StateId: {value : fatherData[0].Addresses[0].State.id , label: fatherData[0].Addresses[0].State.name },
              postalCode: fatherData[0].Addresses[0].postalCode,
            }
        }
      }
      if(motherData.length > 0){
        if(motherData[0].Addresses.length > 0 ){
          parentParams.mother = { 
            id:motherData[0].id,
            name: motherData[0].name,
            email: motherData[0].email,
            dob: motherData[0].dob,
            phone: (motherData[0].phone),
            occupation: motherData[0].occupation,
            altPhoneNumber: motherData[0].altPhoneNumber ? (motherData[0].altPhoneNumber) : null,
            addressLine: motherData[0].Addresses[0].addressLine,
            city: motherData[0].Addresses[0].city,
            district: motherData[0].Addresses[0].district,
            StateId: {value : motherData[0].Addresses[0].State.id , label: motherData[0].Addresses[0].State.name },
            postalCode: motherData[0].Addresses[0].postalCode,
          }
        }
      }
      console.log(parentParams)
      // const parentParams = {
      //   father:{
      //     id: fatherData[0].id ,
      //     name: fatherData[0].name,
      //     email: fatherData[0].email,
      //     dob: fatherData[0].dob,
      //     phone: (fatherData[0].phone),
      //     occupation: fatherData[0].occupation,
      //     altPhoneNumber: fatherData[0].altPhoneNumber ? (fatherData[0].altPhoneNumber) : null ,
      //     ...fatherAddressParams
      //   },
      //   mother:{
      //     id:motherData[0].id,
      //     name: motherData[0].name,
      //     email: motherData[0].email,
      //     dob: motherData[0].dob,
      //     phone: (motherData[0].phone),
      //     occupation: motherData[0].occupation,
      //     altPhoneNumber: motherData[0].altPhoneNumber ? (motherData[0].altPhoneNumber) : null,
      //     ...motherAddressParams
      //   }
      // }
      setStudentData(studentParams)
      setParentData(parentParams)
    }
  }, [studentProfileDetails])
  
  const changeTab =(value)=>{
    setSelectedTab(value);
  } 
  
  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
            <Stepper steps={ [{title: 'Student Bio'},{title: 'Student Details'}, {title: 'Parent Details'}, {title: 'Student Histroy'}, {title: 'Payment History'},{title: 'Delete Student'}] } 
            activeStep={ STUDENTTABORDER.indexOf(selectedTab) } 
            completeBarColor={"#1c5984"} activeTitleColor={"#1c5984"} activeColor={"#1c5984"} completeColor={"#1c5984"} icon={"fa fa-user"}/>
            <hr />
            <div className="custom-tabs pill-tab ">
              <Tab.Container activeKey={selectedTab} id="left-tabs-example" defaultActiveKey={selectedTab}>
                <Nav variant="pills" className="tabs-style-two">
                <Nav.Item>
                    <Nav.Link
                      eventKey={STUDENT_BIO}
                      onClick={() => {
                        setSelectedTab(STUDENT_BIO);
                      }}
                    >
                      <b><i className="fa fa-user"></i>&nbsp; &nbsp;Student Bio</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={STUDENT}
                      onClick={() => {
                        setSelectedTab(STUDENT);
                      }}
                    >
                      <b><i className="fa fa-user"></i>&nbsp; &nbsp;Student Details</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={PARENT}
                      onClick={() => {
                        setSelectedTab(PARENT);
                      }}
                    >
                      <b>Parent Details</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={STUDENT_HISTORY}
                      onClick={() => {
                        setSelectedTab(STUDENT_HISTORY);
                      }}
                    >
                      <b>Student History</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={PAYMENT}
                      onClick={() => {
                        setSelectedTab(PAYMENT);
                      }}
                    >
                      <b>Payment History</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={DELETE_STUDENT}
                      onClick={() => {
                        setSelectedTab(DELETE_STUDENT);
                      }}
                    >
                      <b>Delete Student</b>
                    </Nav.Link>
                  </Nav.Item>
                  
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey={STUDENT_BIO}>
                    <Card>
                    <Card.Header> Student Bio </Card.Header>
                      <Card.Body>
                        {Object.keys(studentProfileDetails).length > 0 ? (
                          <Bio />
                        ):null }
                      
                      </Card.Body>
                    </Card>
                  </Tab.Pane>
                  <Tab.Pane eventKey={STUDENT}>
                    <Card>
                    <Card.Header> Student Details </Card.Header>
                      <Card.Body>
                        {Object.keys(studentProfileDetails).length > 0 && Object.keys(studentData).length > 0 ? (
                          <StudentDetails changeTab={changeTab} redirectFrom={EDIT_ACTION} studentData={studentData} />
                        ):null }
                      
                      </Card.Body>
                    </Card>
                  </Tab.Pane>

                  <Tab.Pane eventKey={PARENT}>
                  <Card>
                    {/* <Card.Header> Parent Details </Card.Header> */}
                      <Card.Body>
                      {
                        Object.keys(studentProfileDetails).length  > 0  && Object.keys(parentData).length > 0 ? (
                         <>
                          <ParentDetails changeTab={changeTab} redirectFrom={EDIT_ACTION} parentData={parentData}/>
                         </>
                        ) : null 
                      }   
                      
                      </Card.Body>
                    </Card>
                    
                  </Tab.Pane>
                  <Tab.Pane eventKey={STUDENT_HISTORY}>
                      
                      {/* <Card>
                      <Card.Header> Student History </Card.Header>
                        <Card.Body> */}
                            <StudentHistory /> 
                           
                        {/* </Card.Body>
                      </Card>            */}
                    </Tab.Pane>
                  <Tab.Pane eventKey={PAYMENT}>
                      
                    <Card>
                    <Card.Header> Payment History </Card.Header>
                      <Card.Body>
                      <StudentPaymentHistory />
                      </Card.Body>
                    </Card>           
                  </Tab.Pane>
                  <Tab.Pane eventKey={DELETE_STUDENT}>
                      
                    <Card>
                    <Card.Header> Delete Student </Card.Header>
                      <Card.Body>
                      {
                        Object.keys(studentProfileDetails).length  > 0 ? (
                         <>
                          <LeavingCertifcate />
                         </>
                        ) : null 
                      }   
                      </Card.Body>
                    </Card>           
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            <hr />
            
        </div>
      </PageLoader>
    </div>
  );
};

export default EditProfile;
